export { AlertComponent } from './alert.component';
export { AlertModule } from './alert.module';
export { AlertConfig } from './alert.config';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
